var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYsfQuestionCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.96859C17.7119 16.9977 9.90219 18.1949 0 12.3318V0C10.2817 8.39369 17.525 9.94686 32 8.96859Z",
    fill: "#6144B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYsfQuestionCurve);
export default __webpack_public_path__ + "static/media/YSFQuestionCurve.961b89fd784d3d3786d923169670795a.svg";
export { ForwardRef as ReactComponent };